import React from 'react';

const TermsPage = () => {
  return (
    <div className="doc-page terms">
      <h1>利用規約</h1>

      <p>この利用規約（以下、「本規約」といいます。）は、Garlic Hamster（ガーリック・ハムスター、以下、「当サイト」といいます。）がこのウェブサイト上で提供するサービス（以下、「本サービス」といいます。）の利用条件を定めるものです。ユーザーの皆さまには、本規約に従って、本サービスをご利用いただきます。</p>

      <h2>第1条（適用）</h2>
      <p>本規約は、ユーザーと当サイトとの間の本サービスの利用に関わる一切の関係に適用されるものとします。当サイトが当サイトのウェブサイト上で掲載するプライバシーポリシーおよびその他の諸規定は、本規約の一部を構成するものとします。</p>

      <h2>第2条（禁止事項）</h2>
      <p>ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
      <ul>
        <li>法令または公序良俗に違反する行為</li>
        <li>犯罪行為に関連する行為</li>
        <li>本サービスの内容等、本サービスに含まれる著作権、商標権ほか知的財産権を侵害する行為</li>
        <li>当サイト、ほかのユーザー、またはその他第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
        <li>当サイトのサービスの運営を妨害するおそれのある行為</li>
        <li>不正アクセスをし、またはこれを試みる行為</li>
        <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
        <li>不正な目的を持って本サービスを利用する行為</li>
        <li>本サービスの他のユーザーまたはその他の第三者に不利益、損害、不快感を与える行為</li>
        <li>当サイトのサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
        <li>その他、当サイトが不適切と判断する行為</li>
      </ul>

      <h2>第3条（本サービスの提供の停止等）</h2>
      <p>当サイトは、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。</p>
      <ul>
        <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
        <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
        <li>コンピュータまたは通信回線等が事故により停止した場合</li>
        <li>その他、当サイトが本サービスの提供が困難と判断した場合</li>
      </ul>
      <p>当サイトは、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。</p>

      <h2>第4条（利用制限）</h2>
      <p>当サイトは、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、ユーザーに対して本サービスの全部もしくは一部の利用を制限することができるものとします。</p>
      <ul>
        <li>本規約のいずれかの条項に違反した場合</li>
        <li>その他、当サイトが本サービスの利用を適当でないと判断した場合</li>
      </ul>
      <p>当サイトは、本条に基づき当サイトが行った行為によりユーザーに生じた損害について、一切の責任を負いません。</p>

      <h2>第5条（保証の否認および免責事項）</h2>
      <p>当サイトは、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。当サイトは、本サービスに起因してユーザーに生じたあらゆる損害について一切の責任を負いません。ただし、本サービスに関する当サイトとユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。</p>

      <h2>第6条（サービス内容の変更等）</h2>
      <p>当サイトは、ユーザーに通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。</p>

      <h2>第7条（利用規約の変更）</h2>
      <p>当サイトは、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。なお、本規約の変更後、本サービスの利用を開始した場合には、当該ユーザーは変更後の規約に同意したものとみなします。</p>

      <h2>第8条（個人情報の取扱い）</h2>
      <p>当サイトは、本サービスの利用によって取得する個人情報については、当サイト「プライバシーポリシー」に従い適切に取り扱うものとします。</p>

      <h2>第9条（準拠法・裁判管轄）</h2>
      <p>本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合には、横浜地方裁判所又は横浜簡易裁判所を、第1審の専属的合意管轄裁判所とします。</p>

      <p>最終更新日：2025年12月15日</p>
    </div>
  );
};

export default TermsPage;
